import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=7d8eb74d&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=7d8eb74d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8eb74d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d8eb74d')) {
      api.createRecord('7d8eb74d', component.options)
    } else {
      api.reload('7d8eb74d', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=7d8eb74d&scoped=true&", function () {
      api.rerender('7d8eb74d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JYZa1XPWxKJL/JS/comp/GuestBox.vue"
export default component.exports